/**
 * Shell — главный layout: Sidebar + Header + Outlet.
 * В Фазе 0 — статическая вёрстка. Будет наполняться в Фазе 1.
 *
 * Phase 2.6: <AuthExpiredModal> монтируется здесь (на одном уровне с Outlet)
 * чтобы покрывать все защищённые страницы. Видимость управляется
 * authStore.expired — модалка не показывается на /login (api.ts guard).
 */
import { Outlet } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { AuthExpiredModal } from '@/components/auth/AuthExpiredModal';
import { useProjectBootstrap } from '@/hooks/useProjectBootstrap';

export function Shell() {
  // Bootstrap currentProjectId со списком /projects (защита от stale id
  // в localStorage, например после pytest TRUNCATE или смены аккаунта).
  // Mounted до Outlet-страниц, чтобы они читали актуальный id из store.
  useProjectBootstrap();

  return (
    <div className="flex min-h-screen bg-surface-950 text-surface-100 overflow-x-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 p-6 overflow-y-auto overflow-x-hidden min-w-0">
          <Outlet />
        </main>
      </div>
      <AuthExpiredModal />
    </div>
  );
}
